
import { NoseurObject } from "@rivtn/noseur";
import { LanuariusBaseService } from "./LanuariusBaseService";
import { SanitizedResponse, ApiResponseData } from "../../BaseService";

export interface ISession {
    id: number;
    status: string;
    ip_address: string;
    created_at: string;
    updated_at: string;
    session_token: string;
    device: {
        os_name: string;
        device_class: string;
        browser_name: string;
    };
    location: {
        state: string;
        country: string;
    };
}

export class SessionService extends LanuariusBaseService {

    protected static instance: SessionService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SessionService.instance) SessionService.instance = new SessionService();
        return SessionService.instance;
    }

    querySession(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<ApiResponseData<ISession>>> {
        return this.report(this.transport.get("/janus/lanuarius/api/v1/session/self", { query: this.normalizeParams(params) }));
    }

    revokeSession(id: number | string): Promise<any> {
        return this.report(this.transport.delete(`/janus/lanuarius/api/v1/session/self/${id}`, { responseType: "noContent" }));
    }

}

